import { InsightType } from "@amzn/d16-g-client-deck-builder-typescript-client";
import React from "react";
import { isNonNullish } from "remeda";
import { useStore } from "zustand";

import type { UnifiedContent } from "../../../../hooks/insightPackages/useInsightPackagesLoader";
import { useContentCardShown } from "../../../../hooks/misc/useContentCardShown";
import { discoveryFilterStore } from "../../../../store/filters";
import type { CardDetail } from "../../../../types/card";
import {
    getAdvertiserId,
    getMarketplaceId,
} from "../../../../utils/permission.utils";
import { CardLayout } from "../insightDetails/CardLayout";
import { InsightPackagesCardAction } from "../insightPackages/InsightPackagesCardAction";

export interface StandaloneRecommendationCardProps {
    recommendation: UnifiedContent;
    index?: number;
    additionalCardDetails?: CardDetail[];
}

export const StandaloneRecommendationCard: React.FunctionComponent<
    StandaloneRecommendationCardProps
> = ({ recommendation, index, additionalCardDetails = [] }) => {
    const {
        identifier: contentId,
        browseNode,
        brand,
        title,
        insightTypeName,
        metadata,
    } = recommendation;
    const insightType = InsightType.CAIRE;
    const description = isNonNullish(metadata)
        ? metadata["description"]
        : undefined;
    const entityId = isNonNullish(metadata) ? metadata["entityId"] : undefined;
    const entityName = isNonNullish(metadata)
        ? metadata["entityName"]
        : undefined;

    useContentCardShown({ identifier: contentId, insightType });

    const marketplaceId = getMarketplaceId();
    const advertiserId = getAdvertiserId();

    const [scopeToLabel] = useStore(discoveryFilterStore, (state) => [
        state.scopeToLabel,
    ]);

    const details: CardDetail[] = [
        ...additionalCardDetails,
        {
            label: "Brand",
            value: brand,
        },
        {
            label: "BN",
            value: browseNode,
            lineClamp: 2,
        },
        {
            label: "Insight type",
            value: insightTypeName ? scopeToLabel[insightTypeName] : undefined,
        },
        ...(entityName
            ? [
                  {
                      label: "Entity Name",
                      value: entityName,
                  },
              ]
            : []),
        {
            label: "Entity id",
            value: entityId,
        },
    ];

    return (
        <CardLayout
            description={title ?? ""}
            details={details}
            actions={
                <InsightPackagesCardAction
                    title={title!}
                    details={details}
                    marketplaceId={marketplaceId!}
                    advertiserId={advertiserId!}
                    recommendationId={contentId!}
                    insightType={insightType}
                    description={description}
                    index={index}
                    metadata={metadata}
                />
            }
            dataTestId={contentId ?? ""}
            key={contentId}
        />
    );
};
